import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";

class PersonModel {
    private serviceName = "/personModel"

    async GetAssigneeList(id: number) {
        isTokenExpired();
        const currentDateTime = new Date().toISOString();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetAssigneeList/${id}?date=${encodeURIComponent(currentDateTime)}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetMenuAccess(personId: any, token: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        let userAPIKey = token ? "Bearer " + token : process.env.REACT_APP_PUBLIC_API_SECURE_KEY;
        return httpCommon.get(`${this.serviceName}/GetMenuAccess/${personId}`, {
            headers: {
                "Authorization": userAPIKey,
            }
        }).catch((err: Error) => {
            throw err?.message
        });
    }
}

export default new PersonModel()